import {
    RunnitNodeFieldDisplaySINGLE_SELECT,
    RunnitNodeFieldSelectOption,
    RunnitNodeFieldImageSelectOption,
    runnitValidateField,
    RunnitFieldValidationResult,
} from '@run-diffusion/shared';

export type ValidationResult = RunnitFieldValidationResult;

/**
 * Extracts options from a SINGLE_SELECT display configuration.
 */
export function getSingleSelectOptions(
    display: RunnitNodeFieldDisplaySINGLE_SELECT | null | undefined,
): (RunnitNodeFieldSelectOption | RunnitNodeFieldImageSelectOption)[] {
    if (!display) return [];
    if (display.text?.options) return display.text.options;
    if (display.radio?.options) return display.radio.options;
    if (display.image?.options) return display.image.options;
    return [];
}

export function validateSingleSelectValue(
    display: RunnitNodeFieldDisplaySINGLE_SELECT | null | undefined,
    value: unknown,
): ValidationResult {
    return runnitValidateField(value, {
        __rfield: true,
        uuid: '',
        fieldDefUuid: '',
        type: 'SINGLE_SELECT',
        display: display ?? {},
    } as any);
}
